import { render, staticRenderFns } from "./trendStatisticsDetail.vue?vue&type=template&id=026798b4&"
import script from "./trendStatisticsDetail.vue?vue&type=script&lang=js&"
export * from "./trendStatisticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./trendStatisticsDetail.vue?vue&type=style&index=0&id=026798b4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports